import { Image } from "@chakra-ui/react";
import Logo from "src/images/safie-logo-basic-a.png";

export const SafieLogoHorizontal = () => (
  <Image
    src={Logo}
    alt="safie-logo"
    w="117.6px"
  />
)